import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import type { MutationError } from '~/types/form';
import { BOOKING_CONTACT } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { BookingContactResponseSchema } from '~/validation/api/bookingContactResponse';

export type CalendarContactFormData = {
  name: string;
  email: string;
  message: string;
  agreement: boolean;
  package_id: number;
  pax: number;
  locale: string;
  office_id: number;
  department_id: number;
  date?: string;
};

type BookingContactRequestOptions = {
  formState: CalendarContactFormData;
};

const sendContactFormMutation = async ({
  formState,
}: BookingContactRequestOptions) => {
  try {
    const response = await axios.post(BOOKING_CONTACT, formState);

    const json = response.data;

    return BookingContactResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function useCalendarContactMutation() {
  return useMutation<any, MutationError, BookingContactRequestOptions>({
    mutationFn: (obj) => {
      return sendContactFormMutation({
        formState: obj.formState,
      });
    },
  });
}
